<div class="academic-year-abroad" *ngIf="courseDetails$ | async as courseDetails">
  <div class="academic-year-abroad__descriptions" data-qa="academicYearAbroad_description" i18n>Price includes tuition and accommodation</div>
  <lx-single-selection-button-list-field
    title="Language"
    i18n-title
    [options]="languages$ | async"
    [ngModel]="courseDetails.selectedLanguage"
    (ngModelChange)="updateSelectedLanguage($event)"
    bindValue="code"
    data-qa="academicYearAbroad_languageField"
  ></lx-single-selection-button-list-field>
  <lx-aya-course-selector-field
    [(selectedValue)]="courseDetails.selectedCourse"
    (selectedValueChange)="updateSelectedCourse($event)"
    data-qa="academicYearAbroad_courseField"
  ></lx-aya-course-selector-field>

  <lx-location-selector-field
    [disabled]="!courseDetails.selectedCourse"
    [groupedSchoolLocations]="groupedSchoolLocations$ | async"
    [selectedValue]="courseDetails.selectedSchoolLocation"
    (selectedValueChange)="updateSelectedSchoolLocation($event)"
    data-qa="academicYearAbroad_locationField"
  />
  <div class="academic-year-abroad__duration-field">
    <lx-single-selection-button-list-field
      title="Duration in months"
      i18n-title
      [options]="durations$ | async"
      [preselected]="false"
      [disabled]="!courseDetails.selectedSchoolLocation"
      [ngModel]="courseDetails.selectedAyaDuration"
      (ngModelChange)="updateSelectedDuration($event)"
      [compareWith]="compareDurations"
      data-qa="academicYearAbroad_durationField"
    ></lx-single-selection-button-list-field>
  </div>

  <lx-fixed-date-selector-field
    (selectedValueChange)="updateSelectedStartDate($event)"
    [disabled]="!courseDetails.selectedAyaDuration"
    [fixedDates]="ayaStartDates$ | async"
    [selectedValue]="{ date: courseDetails?.selectedStartDate }"
    i18n-label
    i18n-title
    label="Start date"
    title="Select a start date"
    data-qa="academicYearAbroad_startDate"
  >
    <lx-dates [startDate]="selectedStartDate()" [endDate]="selectedEndDate()" [emptyMsg]="emptySelectionMsg"></lx-dates>
  </lx-fixed-date-selector-field>
</div>
